// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__A92Wg","disableHover":"IconButton_disableHover__5Pd3c"};